// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__1sqei","lineContainer":"styles_lineContainer__2GUT8","separator":"styles_separator__3vXW_"};